type RouteCategoriesType = {
    hidden: 0,
    everyone: 1,
    unregistered: 2,
    allRegistered: 3,
    admin: 4, 
    groupMember: 5,
    groupLeader: 6,
    userAccount: 7,
}
export const RouteCategories: RouteCategoriesType = {
    hidden: 0,
    everyone: 1,
    unregistered: 2,
    allRegistered: 3,
    admin: 4, 
    groupMember: 5,
    groupLeader: 6,
    userAccount: 7,
}
export type RouteCategoriesValues = typeof RouteCategories[keyof typeof RouteCategories]

export default RouteCategories;